/**
 * Asset file status
 */
var AssetStatus;
(function (AssetStatus) {
  /** Asset available */
  AssetStatus["available"] = "available";
  /** Asset not yet available, waiting for external upload to finish */
  AssetStatus["uploading"] = "uploading";
  /** Asset not yet available, it is still being processed by the server */
  AssetStatus["processing"] = "processing";
  /** Asset not available, due to a server error */
  AssetStatus["error"] = "error";
})(AssetStatus || (AssetStatus = {}));

export { AssetStatus };
